import React, { useState, useEffect, useMemo } from 'react';

const HumanCheck = ({ onValidationChange, error, formType = 'default' }) => {
  const [humanCheck, setHumanCheck] = useState({ question: '', answer: '', userAnswer: '' });

  const questions = useMemo(() => [
    { question: "What is 2 + 3?", answer: "5" },
    { question: "What is 10 - 4?", answer: "6" },
    { question: "What is 3 x 3?", answer: "9" },
    { question: "What is 12 ÷ 4?", answer: "3" },
    { question: "What is 7 + 1?", answer: "8" },
    { question: "What is 6 - 2?", answer: "4" },
    { question: "What is 5 x 2?", answer: "10" },
    { question: "What is 9 ÷ 3?", answer: "3" },
    { question: "What is 4 + 5?", answer: "9" },
    { question: "What is 8 - 3?", answer: "5" },
    { question: "What is 2 x 4?", answer: "8" },
    { question: "What is 15 ÷ 3?", answer: "5" }
  ], []);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * questions.length);
    setHumanCheck({
      question: questions[randomIndex].question,
      answer: questions[randomIndex].answer,
      userAnswer: ''
    });
  }, [questions]);

  const handleHumanCheckChange = (e) => {
    const userAnswer = e.target.value;
    setHumanCheck(_prev => ({
      ..._prev,
      userAnswer: userAnswer
    }));
    
    const isValid = userAnswer.trim() === humanCheck.answer;
    onValidationChange(isValid);
  };

  const generateNewQuestion = () => {
    const randomIndex = Math.floor(Math.random() * questions.length);
    setHumanCheck(_prev => ({
      question: questions[randomIndex].question,
      answer: questions[randomIndex].answer,
      userAnswer: ''
    }));
    onValidationChange(false);
  };

  // Base styles
  const baseStyles = {
    humanCheckField: {
      width: '100%',
      marginBottom: '0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    },
    humanCheckLabel: {
      fontWeight: '600',
      marginBottom: '0.5rem',
      color: 'var(--darkOrange)',
      fontFamily: "'Poppins', Arial, sans-serif",
      fontSize: '1rem',
      lineHeight: '1.5',
      textAlign: 'left'
    },
    humanCheckInputGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      width: '100%'
    },
    humanCheckInput: {
      border: '2px solid #e9ecef',
      borderRadius: '12px',
      padding: '1rem',
      fontSize: '1rem',
      lineHeight: '1.5',
      boxSizing: 'border-box',
      transition: 'all 0.3s ease',
      background: 'white',
      color: '#333'
    },
    humanCheckError: {
      borderColor: '#dc3545',
      boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.15)'
    },
    humanCheckButton: {
      background: 'var(--darkPurple)',
      color: 'var(--darkOrange)',
      border: 'none',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      flexShrink: '0', 
      padding: '8px',
      fontSize: '14px', 
      minWidth: '40px', 
      minHeight: '40px'
    },
    humanCheckErrorText: {
      color: '#dc3545',
      fontSize: '0.875rem',
      marginTop: '0.25rem',
      fontWeight: '500'
    }
  };

  // Form-specific styles
  const getFormStyles = () => {
    switch (formType) {
      case 'contact':
        return {
          ...baseStyles,
          humanCheckInput: {
            ...baseStyles.humanCheckInput,
            width: '200px',
            flex: '0 0 auto'
          }
        };
      case 'register':
      case 'registerTeacher':
      case 'registerOrg':
      case 'registerStudent':
        return {
          ...baseStyles,
          humanCheckInput: {
            ...baseStyles.humanCheckInput,
            width: '150px',
            flex: '0 0 auto'
          }
        };
      default:
        return {
          ...baseStyles,
          humanCheckInput: {
            ...baseStyles.humanCheckInput,
            width: '180px',
            flex: '0 0 auto'
          }
        };
    }
  };

  const styles = getFormStyles();

  return (
    <div style={styles.humanCheckField}>
      <label htmlFor="humanCheck" style={styles.humanCheckLabel}>{humanCheck.question}</label>
      <div style={styles.humanCheckInputGroup}>
        <input
          type="text"
          style={{
            ...styles.humanCheckInput,
            ...(error ? styles.humanCheckError : {})
          }}
          id="humanCheck"
          placeholder="Your answer"
          value={humanCheck.userAnswer}
          onChange={handleHumanCheckChange}
          required
        />
        <button
          type="button"
          style={styles.humanCheckButton}
          onClick={generateNewQuestion}
          title="Get a different question"
        >
          <i className="fas fa-refresh"></i>
        </button>
      </div>
      {error && <div style={styles.humanCheckErrorText}>{error}</div>}
    </div>
  );
};

export default HumanCheck; 